import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsFirstTx({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id="Group"><circle id="Oval" cx={8} cy={8} r={7} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path" d="M3 12.8972V19.9993C3 20.1694 3.08643 20.3278 3.22944 20.4198C3.37244 20.5118 3.55241 20.5248 3.70718 20.4544L8 18.4999L12.2928 20.4544C12.4476 20.5248 12.6276 20.5118 12.7706 20.4198C12.9136 20.3278 13 20.1694 13 19.9993V12.8972" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g></Svg>;
}
export default OrdinalsFirstTx;